import {CSSProperties} from 'react';

import {CSSObject, Interpolation, css} from 'styled-components';

const wh = (width: CSSProperties['width'], height?: CSSProperties['height']) => css`
  width: ${width};
  height: ${height ?? width};
`;

const round = (size: CSSProperties['width']) => css`
  ${wh(size)}
  overflow: hidden;
  border-radius: 50%;
`;

const sizes = {
  mobileS: 320,
  mobileM: 375,
  mobileL: 425,
  tablet: 768,
  laptop: 1024,
  laptopM: 1281,
  laptopL: 1440,
  fourK: 2560,
};

type TMedia = Record<
  keyof typeof sizes,
  (
    first: TemplateStringsArray | CSSObject,
    ...interpolations: Interpolation<object>[]
  ) => Interpolation<object>
>;

const media = (Object.keys(sizes) as (keyof typeof sizes)[]).reduce((acc: TMedia, label) => {
  acc[label] = (first, ...interpolations) => css`
    @media (min-width: ${sizes[label]}px) {
      ${css(first, ...interpolations)}
    }
  `;

  return acc;
}, {} as TMedia);

const paper = css`
  ${({theme}) => css`
    background-color: ${theme.palette.white};
    border-radius: ${theme.borderRadius.br1};
    box-shadow: ${theme.boxShadow.default};
  `};
`;

type TPosition = Pick<
  CSSProperties,
  'position' | 'top' | 'right' | 'bottom' | 'left' | 'transform'
>;

const position = ({position: pos, top, right, bottom, left, transform}: TPosition) => css`
  ${pos !== undefined && `position: ${pos}`};
  ${top !== undefined && `top: ${top}`};
  ${right !== undefined && `right: ${right}`};
  ${bottom !== undefined && `bottom: ${bottom}`};
  ${left !== undefined && `left: ${left}`};
  ${transform !== undefined && `transform: ${transform}`};
`;

const disabled = css`
  color: ${({theme}) => theme.palette.grey300};
  cursor: not-allowed;
`;

const pureButton = css`
  cursor: pointer;
  flex-shrink: 0;
  padding: 0;
  background-color: transparent;
  outline: none;
  border: none;
`;

export const commonMixins = {
  wh,
  round,
  media,
  paper,
  position,
  disabled,
  pureButton,
} as const;
export type {TMedia, TPosition};
